module.exports = __webpack_public_path__ + "static/media/cort-furniture_2x.086a6e6a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/header-photos/cort-furniture_2x.jpg
// module id = 760
// module chunks = 27